import React, { useState } from 'react'
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { Layout } from "antd";
const { Header, Content } = Layout;
const Dashboard = ({children}) => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const toggleDrawer = () => {
      setDrawerVisible(!drawerVisible);
    };

  return (
    <Layout className='w-100 h-100 bg-white'>
      <AdminSidebar drawerVisible={drawerVisible} toggleDrawer={toggleDrawer} />
      <Layout>
        <AdminHeader toggleDrawer={toggleDrawer}/>
        <Content className="bg-white w-100">{children}</Content>
      </Layout>
    </Layout>
  )
}

export default Dashboard